import react from "react";

export const LoadingContext = react.createContext();
